import PropTypes from 'prop-types';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';

const ListRefreshButton = ({ refreshing = false, onRefresh }) => (
  <Tooltip title="Refresh table">
    <span className="transaction-toolbar-refresh">
      <IconButton
        aria-label="Refresh table"
        onClick={onRefresh}
        disabled={refreshing}
        size="small"
        sx={{
          width: 40,
          height: 40,
          border: '1px solid #0b6e99',
          borderRadius: '8px',
          color: '#0b6e99',
          backgroundColor: '#fff',
          '&:hover': { backgroundColor: 'rgb(11 110 153 / 0.06)' }
        }}
      >
        {refreshing ? <CircularProgress size={18} /> : <RefreshOutlinedIcon fontSize="small" />}
      </IconButton>
    </span>
  </Tooltip>
);

ListRefreshButton.propTypes = {
  refreshing: PropTypes.bool,
  onRefresh: PropTypes.func.isRequired
};

export default ListRefreshButton;
